/* eslint-disable key-spacing */
export const defaultCollapseTheme = {
  bodyOpened:           'opened',
  bodyWrapper:          'collapse-body-wrapper',
  headingDisabled:      'heading-disabled',
  headingIcon:          'collapse-heading-icon',
  headingIconOpen:      'icon-expanded',
  headingWrapper:       'collapse-heading-wrapper',
};
